import {
  destroy as destroyTabs,
  init as initTabs,
} from 'assets/utilities/tabs';

import './faq.scss';

const bind = function bindFaq() {
  initTabs();
};

const init = function initFaq() {
  bind();
};

const destroy = function destroyFaq() {
  destroyTabs();
};

export default {
  destroy,
  init,
};
